import Dict from '@/utils/dict-utils'

/**
 * 工作流状态
 * @property {1} NORMAL 正常
 * @property {0} FORBIDDEN 禁用
 * @type {DictUtil}
 */
export const workflowStatusDict = new Dict({
  NORMAL: { value: 1, label: '启用', type: 'success' },
  FORBIDDEN: { value: 2, label: '禁用', type: 'danger' }
})

/**
 * 审核流业务类型
 * @property {1} BUSINESS_TYPE 业务类型
 * @property {2} BUSINESS_NODE 业务节点
 */
export const workflowBusinessTypeDict = new Dict({
  BUSINESS_TYPE: { value: 1, label: '业务类型' },
  BUSINESS_NODE: { value: 2, label: '业务节点' }
})

/**
 * 单个任务状态字典
 * 审批方式
 * @property {1} IN_TURN 依次审批
 * @property {2} AND 与签
 * @property {3} OR 或签
 */
export const workflowAuditMethodDict = new Dict({
  // IN_TURN: { value: 1, label: '依次审批', desc: '审批人按添加顺序依次审批' },
  AND: { value: 2, label: '会签', desc: '须所有审批人同意' },
  OR: { value: 3, label: '或签', desc: '一名审批人同意或拒绝即可' }
})

/**
 * 待办事项详情审核类型
 * @property {1} PENDING_REVIEW 待审核/未读
 * @property {2} PASS 审核通过/已读
 * @property {3} NO_PASS 审核不通过/拒绝
 */
export const workflowAuditStatusDict = new Dict({
  PASS_PENDING: { value: 0, label: '审批中' },
  PASS: { value: 1, label: '审批通过' },
  PASS_REJECT: { value: 2, label: '审批不通过' }
})

/**
 * 全流程状态字典
 */
export const workflowAuditCheckDict = new Dict({
  INIT: {
    label: '待审批',
    value: 0,
    type: 'primary',
    text: 'primary',
    icon: 'info'
  },
  PASS_PENDING: {
    value: 1,
    label: '审批中',
    type: 'warning',
    text: 'warning',
    icon: 'warning'
  },
  PASS: {
    value: 2,
    label: '审批通过',
    type: 'success',
    text: 'success',
    icon: 'success'
  },
  PASS_REJECT: {
    value: 3,
    label: '审批不通过',
    type: 'error',
    text: 'danger',
    icon: 'error'
  },
  PASS_REVOKE: {
    value: 4,
    label: '已撤销',
    type: 'info',
    text: 'info',
    icon: 'info'
  }
})

/**
 * 审核操作字典
 */
export const workflowAuditOperateDict = new Dict({
  PASS: { value: 1, label: '通过' },
  REJECT: { value: 2, label: '拒绝' }
})

/**
 * 节点类型字典
 */
export const workflowNodeTypeDict = new Dict({
  START: { value: 'start', label: '开始' },
  APPROVER: { value: 'approver', label: '审核' },
  CONDITION: { value: 'condition', label: '条件' },
  COPY: { value: 'copy', label: '抄送' }
})

/**
 * 身份类型字典
 */
export const workflowIdentityDict = new Dict({
  COPYPERSON: { value: 'copyPerson', label: '抄送人' },
  INITIATEPERSON: { value: 'initatPerson', label: '发起人' },
  AUDITPERSON: { value: 'auditPerson', label: '审核人' }
})
